import * as types from '../actionType';
import {GetStoreRole} from '../../const/constant';

let initState = {
  isLogin: false || localStorage.getItem('isLogin') === 'true',
  adminName: localStorage.getItem('adminName'),
  currentStore: localStorage.getItem('current_store_id'),
  access_token: localStorage.getItem('access_token'),
  isRemberMe: false || localStorage.getItem('isRemberMe') === 'true',
}

function LoginState(state = initState, action) {
  switch (action.type) {
    case types.UPDATE_STORE: {
      let newObj = Object.assign({},state);
      newObj.currentStore = localStorage.getItem('current_store_id');

      return newObj;
    }


    case types.ADMIN_LOGIN_SUCCESS: {
      let { error, access_token, username, role, storeId='1,2,3', roles='4,4'  } = action.result;
      console.log(action)
      console.log(action.result)
      let newObj = Object.assign({},state);
      if(error.toString().trim() === "1") {
        newObj.isLogin = true;
        newObj.access_token = access_token;
        newObj.adminName = username;
        newObj.role = role;
        var roleArray = roles.split(',')
        newObj.role1 = roleArray[0];
        newObj.role2 = roleArray[1];

        if(roleArray.length === 3)
          newObj.role3 = roles.split(',')[2];
        else
          newObj.role3 = -1;

        if(storeId.length === 1){
          localStorage.setItem('current_store_id', storeId);
          newObj.currentStore = storeId;

        }
        localStorage.setItem('isLogin', true);
        localStorage.setItem('adminName', newObj.adminName);
        localStorage.setItem('username', action.username);
        localStorage.setItem('role', GetStoreRole(localStorage.getItem('current_store_id')));
        localStorage.setItem('role1', newObj.role1);
        localStorage.setItem('role2', newObj.role2);
        localStorage.setItem('role3', newObj.role3);
        localStorage.setItem('access_token', newObj.access_token);
        localStorage.setItem('all_store_id', storeId);
        localStorage.setItem('detailroleId1', action.result.detailroleId1);
        localStorage.setItem('detailroleId2', action.result.detailroleId2);
        localStorage.setItem('detailroleId3', action.result.detailroleId3);



        if(newObj.isRemberMe === true) {
          localStorage.setItem('rememberAdminName', action.username);
        } else {
          localStorage.removeItem('rememberAdminName');
        }

        if(process.env.REACT_APP_NODE_ENV === "development") console.log(newObj);
      } else {
        console.log(action.result);
      }
      return newObj;
    }
    case types.LOGOUT_SUCCESS: {
      let newObj = Object.assign({},state)
      newObj.isLogin = false;
      newObj.adminName="";
      newObj.access_token="";
      newObj.currentStore = null;

      localStorage.removeItem('isLogin');
      localStorage.removeItem('adminName');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('access_token');
      localStorage.removeItem('all_store_id');
      localStorage.removeItem('current_store_id');
      localStorage.removeItem('temp_store_id');
      localStorage.removeItem('detailroleId1');
      localStorage.removeItem('detailroleId2');
      localStorage.removeItem('detailroleId3');
      return newObj;
    }
    case types.SWITCH_REMEMBER_ME: {
      let newObj = Object.assign({},state);
      newObj.isRemberMe = !newObj.isRemberMe;
      localStorage.setItem('isRemberMe', newObj.isRemberMe);
      if(newObj.isRemberMe === false) {
        localStorage.removeItem('rememberAdminName');
      }
      return newObj
    }
    default:
      return state;
  }
}

export default LoginState;